var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgError = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 40"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M20 0a20 20 0 1 0 20 20A20 20 0 0 0 20 0m0 38a18 18 0 1 1 18-18 18 18 0 0 1-18 18"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M19 8h2v16h-2z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 29,
  r: 2,
  fill: "currentColor"
})));
export default SvgError;